import _ from 'lodash';
import React from 'react';
import {
  ApprovalStatusFilter,
  ClientApprovalStatusFilter,
  InvoicedFilter,
  TimeBillableTypeFilter,
  TimeOffTypeFilter,
} from '~/components';
import { useFeatures } from '~/hooks';
import FiltersGroup from './FiltersGroup';
import ReportPeriodFilter from './ReportPeriodFilter';

export default function TimeFiltersGroup({ filters, onChange }) {
  const features = useFeatures();

  return (
    <FiltersGroup
      label="Time Filters"
      filters={[
        filters.createdPeriod?.start,
        filters.createdPeriod?.end,
        filters.modifiedPeriod?.start,
        filters.modifiedPeriod?.end,
        filters.timeBillableTypes,
        filters.timeOffTypes,
        filters.timeApprovalStatuses,
        filters.timeClientApprovalStatuses,
        filters.timeInvoiced,
      ]}>
      {_.has(filters, 'createdPeriod') && (
        <ReportPeriodFilter
          value={filters.createdPeriod}
          placeholder="Created Date Range"
          onChange={({ target: { value } }) => onChange({ createdPeriod: value })}
        />
      )}

      {_.has(filters, 'modifiedPeriod') && (
        <ReportPeriodFilter
          value={filters.modifiedPeriod}
          placeholder="Modified Date Range"
          onChange={({ target: { value } }) => onChange({ modifiedPeriod: value })}
        />
      )}

      {_.has(filters, 'timeBillableTypes') && (
        <TimeBillableTypeFilter
          value={filters.timeBillableTypes}
          onChange={({ target: { value } }) => onChange({ timeBillableTypes: value })}
        />
      )}

      {_.has(filters, 'timeOffTypes') && (
        <TimeOffTypeFilter
          value={filters.timeOffTypes}
          onChange={({ target: { value } }) => onChange({ timeOffTypes: value })}
        />
      )}

      {_.has(filters, 'timeApprovalStatuses') && (
        <ApprovalStatusFilter
          value={filters.timeApprovalStatuses}
          onChange={({ target: { value } }) => onChange({ timeApprovalStatuses: value })}
        />
      )}

      {features.clientApprovals && _.has(filters, 'timeClientApprovalStatuses') && (
        <ClientApprovalStatusFilter
          value={filters.timeClientApprovalStatuses}
          onChange={({ target: { value } }) => onChange({ timeClientApprovalStatuses: value })}
        />
      )}

      {_.has(filters, 'timeInvoiced') && (
        <InvoicedFilter
          value={filters.timeInvoiced}
          onChange={({ target: { value } }) => onChange({ timeInvoiced: value })}
        />
      )}
    </FiltersGroup>
  );
}
